module.exports = __webpack_public_path__ + "img/close_eye.dfac3796.svg";